import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;

axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
axios.defaults.headers.common["apiKey"] = process.env.REACT_APP_API_KEY;
axios.defaults.headers.common["user_key"] = process.env.REACT_APP_API_KEY;

const get = async (endpoint) => {
  addToken();
  return axios.get(`${baseURL}/${endpoint}`);
};

const getAnonymous = async (endpoint) => {
  return axios.get(`${baseURL}/${endpoint}`);
};

const patch = async (endpoint) => {
  return axios.patch(`${baseURL}/${endpoint}`);
};

const getGeneric = (endpoint) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          resolve(xhr.response);
        } else {
          reject(xhr.response);
        }
      }
    };

    xhr.open("GET", endpoint);
    xhr.setRequestHeader(
      "Access-Control-Allow-Methods",
      "GET, POST, PATCH, PUT, DELETE, OPTIONS"
    );
    xhr.setRequestHeader(
      "Access-Control-Allow-Headers",
      "Origin, Content-Type, X-Auth-Token"
    );
    xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.send();
  });
};

const post = async (endpoint, data) => {
  return axios.post(`${baseURL}/${endpoint}`, data);
};

const put = async (endpoint, id, data, recaptcha = null) => {
  // let axiosConfig = {
  //     headers: {
  //         'Recaptcha': recaptcha,
  //     }
  // };
  return axios.put(`${baseURL}/${endpoint}/${id}`, data /*, axiosConfig */);
};

const putFiles = async (endpoint, data) => {
  let axiosConfig = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  return axios.put(`${baseURL}/${endpoint}`, data, axiosConfig);
};

const updateMany = async (endpoint, data /*, recaptcha*/) => {
  // let axiosConfig = {
  //     headers: {
  //         'Recaptcha': recaptcha,
  //     }
  // };
  return axios.put(`${baseURL}/${endpoint}`, data /*, axiosConfig*/);
};

const onDelete = async (endpoint, id) => {
  return axios.delete(`${baseURL}/${endpoint}/${id}`);
};

const addToken = () => {
  const tokenLocalStorage = localStorage.getItem("token-ARS");
  if (tokenLocalStorage) {
    axios.interceptors.request.use(
      (config) => {
        const lastToken =
          tokenLocalStorage != localStorage.getItem("token-ARS")
            ? localStorage.getItem("token-ARS")
            : tokenLocalStorage;
        const token = `Bearer ${lastToken}`;
        if (token) {
          config.headers.common["Authorization"] = token;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }
};

export {
  get,
  post,
  put,
  onDelete,
  addToken,
  updateMany,
  putFiles,
  getAnonymous,
  getGeneric,
  patch,
};
